import { cva } from "class-variance-authority"

export const sliderBaseVariants = cva(
  "relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col",
  {
    variants: {
      size: {
        tiny: "h-3",
        sm: "h-3 my-px",
        md: "h-4 my-px",
        lg: "h-5",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
)

export const sliderBaseTrackVariants = cva(
  // No rail thickness here — the size variant owns it (SliderBase applies this
  // cva without twMerge, so a hardcoded base height would always beat the
  // variant by stylesheet order). Mirrors the reference slider.
  "bg-muted relative grow overflow-hidden rounded-full data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full",
  {
    variants: {
      size: {
        tiny: "data-[orientation=horizontal]:h-1 data-[orientation=vertical]:w-1",
        sm: "data-[orientation=horizontal]:h-1 data-[orientation=vertical]:w-1",
        md: "data-[orientation=horizontal]:h-1.5 data-[orientation=vertical]:w-1.5",
        lg: "data-[orientation=horizontal]:h-2 data-[orientation=vertical]:w-2",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
)

// The range fills the track, so it inherits the track's size; a size variant
// here would only fight `h-full`.
export const sliderBaseRangeVariants = cva(
  "bg-primary absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full",
  {
    variants: {
      size: {
        tiny: "",
        sm: "",
        md: "",
        lg: "",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
)

export const sliderBaseThumbVariants = cva(
  // No size here — the size variant owns the thumb dims (same twMerge caveat
  // as the track).
  "border-primary ring-ring/50 block shrink-0 rounded-full border bg-white shadow-sm transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      size: {
        tiny: "h-3 w-3",
        sm: "h-3 w-3 py-px",
        md: "h-4 w-4 py-px",
        lg: "h-5 w-5",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
)
